(() => {
  'use strict';

  const positionKey = 'seulab:return-position:v1';
  const currentLocationKey = () => `${window.location.pathname}${window.location.search}`;

  const readPosition = () => {
    try {
      const raw = sessionStorage.getItem(positionKey);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  };

  const writePosition = (data) => {
    try { sessionStorage.setItem(positionKey, JSON.stringify(data)); }
    catch (_) {}
  };

  const clearPosition = () => {
    try { sessionStorage.removeItem(positionKey); }
    catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try { url = new URL(link.href, window.location.href); }
    catch (_) { return; }

    if (url.origin !== window.location.origin) return;
    if (!/^\/products\//.test(url.pathname)) return;
    if (/^\/products\//.test(window.location.pathname)) return;

    writePosition({
      source: currentLocationKey(),
      y: Math.max(0, window.scrollY || window.pageYOffset || 0),
      savedAt: Date.now()
    });
  }, true);

  const restorePosition = (event) => {
    const saved = readPosition();
    if (!saved || saved.source !== currentLocationKey()) return;
    if (!saved.savedAt || Date.now() - saved.savedAt > 6 * 60 * 60 * 1000) {
      clearPosition();
      return;
    }

    const navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    const isBackForward = Boolean(event && event.persisted) || (navEntry && navEntry.type === 'back_forward');
    if (!isBackForward) return;

    const y = Number(saved.y) || 0;
    const apply = () => window.scrollTo(0, y);
    requestAnimationFrame(() => {
      apply();
      requestAnimationFrame(apply);
    });
    setTimeout(apply, 120);
    setTimeout(() => {
      apply();
      clearPosition();
    }, 420);
  };

  window.addEventListener('pageshow', restorePosition);

  const mountBackToTop = () => {
    if (document.querySelector('.seulab-back-to-top')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'seulab-back-to-top';
    button.setAttribute('aria-label', 'Sayfanın başına dön');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5"></path><path d="m6.5 10.5 5.5-5.5 5.5 5.5"></path></svg>';
    document.body.appendChild(button);

    const sync = () => button.classList.toggle('is-visible', window.scrollY > 650);
    button.addEventListener('click', () => {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBackToTop, { once: true });
  } else {
    mountBackToTop();
  }

  document.addEventListener('shopify:section:load', mountBackToTop);
})();
